import { useEffect } from 'react';

// Belt-and-suspenders against browser back-nav on horizontal trackpad swipes.
// The primary defense is `html { overscroll-behavior: none }` in index.css;
// this hook preventDefaults horizontal-dominant wheels as a backup for edge
// cases (e.g. two pointer devices at once, where Chrome's heuristics get fuzzy).
// We must NOT preventDefault vertical-dominant wheels — that would break
// scrolling in panels, chat, and the code editor.
export default function useNoGestures(ref: React.RefObject<HTMLElement>) {
	useEffect(() => {
		const el = ref.current;
		if (!el) return;

		const onWheel = (e: WheelEvent) => {
			// The code editor manages its own scroll; never interfere.
			if (e.target instanceof Element && e.target.closest('.cm-editor')) return;

			if (Math.abs(e.deltaX) > Math.abs(e.deltaY)) {
				e.preventDefault();
			}
		};

		el.addEventListener('wheel', onWheel, { passive: false });
		return () => el.removeEventListener('wheel', onWheel);
	}, [ref]);
}
